import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HeroSection = styled.section`
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #F9FAFB 0%, #FFFFFF 100%);
  padding-top: 4rem;
`;

export const GridBackground = styled.div`
  position: absolute;
  inset: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 0V100M21 0V100M41 0V100M61 0V100M81 0V100M0 1H100M0 21H100M0 41H100M0 61H100M0 81H100' stroke='%232C3E50' stroke-opacity='0.03'/%3E%3C/svg%3E"),
    url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 0V100M21 0V100M41 0V100M61 0V100M81 0V100M0 1H100M0 21H100M0 41H100M0 61H100M0 81H100' stroke='%234CAF50' stroke-opacity='0.15'/%3E%3C/svg%3E");
  background-size: 100px 100px;
  background-position: 0 0;
  mask-image: linear-gradient(180deg, white 0%, white 80%, rgba(255,255,255,0) 100%);
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 10;
  max-width: ${({ theme }) => theme.sizes.maxWidth};
  margin: 0 auto;
  padding: 0 1rem;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 1.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0 2rem;
  }
`;

export const HeroTitle = styled.h1`
  font-size: 2.25rem;
  font-family: ${({ theme }) => theme.fonts.serif};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 1.5rem;
  line-height: 1.2;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 3.75rem;
  }
`;

export const HeroSubtitle = styled.p`
  font-size: 1.25rem;
  color: #4B5563;
  margin-bottom: 2rem;
  max-width: 48rem;
  margin-left: auto;
  margin-right: auto;
  font-weight: 300;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

export const Button = styled(Link)`
  padding: 0.75rem 2rem;
  font-weight: 600;
  transition: background-color 0.2s;
  text-decoration: none;

  ${props => props.primary ? `
    background-color: #111827;
    color: white;
    &:hover {
      background-color: #1F2937;
    }
  ` : `
    background-color: white;
    color: #111827;
    border: 1px solid #111827;
    &:hover {
      background-color: #F9FAFB;
    }
  `}
`;

export const ExpertiseSection = styled.section`
  padding: 6rem 0;
  background-color: white;
`;

export const ExpertiseContent = styled.div`
  max-width: ${({ theme }) => theme.sizes.maxWidth};
  margin: 0 auto;
  padding: 0 1rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 1.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0 2rem;
  }
`;

export const ExpertiseHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

export const ExpertiseTitle = styled.h2`
  font-size: 1.875rem;
  font-family: ${({ theme }) => theme.fonts.serif};
  font-weight: 700;
  color: #111827;
  margin-bottom: 1rem;
`;

export const ExpertiseSubtitle = styled.p`
  font-size: 1.25rem;
  color: #4B5563;
  font-weight: 300;
`;

export const ExpertiseGrid = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: 1fr;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ExpertiseCard = styled.div`
  padding: 2rem;
  background-color: white;
  border: 1px solid #E5E7EB;
  transition: border-color 0.2s;

  &:hover {
    border-color: #111827;
  }
`;

export const CardIcon = styled.div`
  color: #111827;
  margin-bottom: 1.5rem;
  svg {
    width: 3rem;
    height: 3rem;
  }
`;

export const CardTitle = styled.h3`
  font-size: 1.25rem;
  font-family: ${({ theme }) => theme.fonts.serif};
  font-weight: 700;
  margin-bottom: 0.75rem;
`;

export const CardDescription = styled.p`
  color: #4B5563;
  font-weight: 300;
`;

export const CTASection = styled.section`
  padding: 6rem 0;
  background-color: #F9FAFB;
`;

export const CTAContent = styled.div`
  max-width: ${({ theme }) => theme.sizes.maxWidth};
  margin: 0 auto;
  padding: 0 1rem;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 1.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0 2rem;
  }
`;

export const CTATitle = styled.h2`
  font-size: 1.875rem;
  font-family: ${({ theme }) => theme.fonts.serif};
  font-weight: 700;
  color: #111827;
  margin-bottom: 1rem;
`;

export const CTADescription = styled.p`
  font-size: 1.25rem;
  color: #4B5563;
  margin-bottom: 2rem;
  max-width: 36rem;
  margin-left: auto;
  margin-right: auto;
  font-weight: 300;
`; 